import { render, staticRenderFns } from "./Load.vue?vue&type=template&id=1ff83d98&scoped=true"
import script from "./Load.vue?vue&type=script&lang=js"
export * from "./Load.vue?vue&type=script&lang=js"
import style0 from "./Load.vue?vue&type=style&index=0&id=1ff83d98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ff83d98",
  null
  
)

export default component.exports